"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import {
  FrontendContainer,
  createDefaultFrontendContainer,
} from "./FrontendContainer";
import { getAuthHeader } from "@/lib/recordsApi";

const FrontendContainerContext = createContext<FrontendContainer | null>(null);

interface FrontendProviderProps {
  children: ReactNode;
  container?: FrontendContainer;
}

/**
 * Provides the FrontendContainer instance to the React tree.
 */
export function FrontendProvider({
  children,
  container,
}: FrontendProviderProps) {
  const value = useMemo(() => {
    if (container) {
      return container;
    }

    return createDefaultFrontendContainer({
      authHeadersProvider: async () => await getAuthHeader(),
    });
  }, [container]);

  return (
    <FrontendContainerContext.Provider value={value}>
      {children}
    </FrontendContainerContext.Provider>
  );
}

export function useFrontendContainer(): FrontendContainer {
  const context = useContext(FrontendContainerContext);
  if (!context) {
    throw new Error("useFrontendContainer must be used within FrontendProvider");
  }
  return context;
}

